import { Injectable } from '@angular/core';
import {BehaviorSubject, combineLatest} from "rxjs";
import {NgxSpinnerService} from "ngx-spinner";

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private apiLoadingSubject = new BehaviorSubject<boolean>(false);
  private formLoadingSubject = new BehaviorSubject<boolean>(false);

  apiLoading$ = this.apiLoadingSubject.asObservable();
  formLoading$ = this.formLoadingSubject.asObservable();

  constructor(private spinner: NgxSpinnerService) {
    // Using combineLatest to track both loading states
    this.combineLoadingState();
  }

  setApiLoading(state: boolean) {
    this.apiLoadingSubject.next(state);
  }

  setFormLoading(state: boolean) {
    this.formLoadingSubject.next(state);
  }

  private combineLoadingState() {
    // Combine both loading states and subscribe to the latest values
    combineLatest([this.apiLoadingSubject, this.formLoadingSubject]).subscribe(
        ([apiLoading, formLoading]) => {
          // If either apiLoading or formLoading is true, show the spinner
          if (apiLoading || formLoading) {
            this.spinner.show();
          } else {
            this.spinner.hide();
          }
        }
    );
  }
}
